import React from 'react';
import PreviousVersionLink from "./PreviousVersionLink";
import AddPreviousVersionsDropDown from "./AddPreviousVersionsDropDown";
import {List, ListItem} from "@mui/material";
import {InstrumentShortVersion} from "../../gen/api";
import DeleteButton from "../DeleteButton/DeleteButton";

type Props = {
  previousInstruments: InstrumentShortVersion[]
  setPreviousInstruments: React.Dispatch<React.SetStateAction<InstrumentShortVersion[]>>
}

function PreviousVersionsEdit({previousInstruments, setPreviousInstruments}: Props) {

  function removePreviousVersion(instrumentToDelete: InstrumentShortVersion) {
    setPreviousInstruments([...previousInstruments.filter(instrument => instrument.id !== instrumentToDelete.id)]);
  }

  return (
      <>
        <List>
          {previousInstruments.map(instrument =>
              <ListItem key={instrument.id}>
                <PreviousVersionLink instrument={instrument}/>
                <DeleteButton onClick={_ => removePreviousVersion(instrument)}/>
              </ListItem>)}
        </List>

        <AddPreviousVersionsDropDown previousInstruments={previousInstruments}
                                     setPreviousInstruments={setPreviousInstruments}/>
      </>
  );
}

export default PreviousVersionsEdit;
